import * as HttpService from "../../../../service/HttpService"

/** 系统管理  -> 业务包管理服务 **/

/**
 * 获取业务包列表
 * @param params 参数列表
 */
export const getBusinessPackageList = (params) => {
    const {appId, className} = params;
    const packageId = params.packageId || "";
    const parentId = params.parentId || "";
    const sub = "appId=" + appId + "&className=" + className + "&packageId=" + packageId + "&parentId=" + parentId;
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/pkgmgmt/child/list?" + sub);
}

/**
 * 新增业务包
 * @param packageInfo 业务包信息
 */
export const addBusinessPackage = (packageInfo) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/pkgmgmt/addPackageDo", packageInfo);
}

/**
 * 删除业务包
 * @param packageId 业务包id
 */
export const deleteBusinessPackage = (packageId) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/pkgmgmt/deletePackage/" + packageId);
}

/**
 * 编辑业务包
 * @param packageInfo 业务包信息
 */
export const editBusinessPackage = (packageInfo) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/pkgmgmt/editPackageDo", packageInfo);
}

/**
 * 新增功能组件
 * @param moduleInfo 功能组件信息
 */
export const addModule = (moduleInfo) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/pkgmgmt/addModuleDo", moduleInfo);
}

/**
 * 删除功能组件
 * @param moduleId 功能组件id
 */
export const deleteModule = (moduleId) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/pkgmgmt/deleteModule/" + moduleId);
}

/**
 * 编辑功能组件
 * @param moduleInfo 功能组件信息
 */
export const editModule = (moduleInfo) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/pkgmgmt/editModuleDo", moduleInfo);
}

